import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";


const Requirements = ({ questionData }) => {
  const [open, setOpen] = useState("1");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <Accordion
      open={open}
      toggle={toggle}
       className="req-accordion"
    >
      <AccordionItem>
        <AccordionHeader targetId="1" className="heading">
          Requirement
        </AccordionHeader>
        <AccordionBody accordionId="1">
          <div className="d-flex justify-content-between mb-3">
            <span className="pe-3 greyTitle w-25 text-start">OrderId</span>
            <span className="ps-3 subTitle fw-bold text-end">
              {questionData?.displayId}
            </span>
          </div>

          {localStorage.getItem("serviceType") ==="CourseHelp" ? (
            <div>

<div className="d-flex  justify-content-between mb-3">
            <span className="pe-3 greyTitle w-25 text-start">Course Type</span>
            <span className="ps-3 subTitle  text-end">
              {questionData?.courseInnerType}
            </span>
          </div>


          <div className="d-flex  justify-content-between mb-3">
            <span className="pe-3 greyTitle w-25 text-start">Course Name</span>
            <span className="ps-3 subTitle  text-end">
              {questionData?.courseId?.courseName}
            </span>
          </div>


           <div className="d-flex  justify-content-between mb-3">
            <span className="pe-3 greyTitle w-25 text-start">University</span>
            <span className="ps-3 subTitle  text-end">
              {questionData?.university}
            </span>
          </div>

            </div>
          ):(
            <div>
          <div className="d-flex  justify-content-between mb-3">
            <span className="pe-3 greyTitle w-25 text-start">Subject</span>
            <span className="ps-3 subTitle  text-end">
              {questionData?.subjectId?.subSubjectName}
            </span>
          </div>

          <div className="d-flex  justify-content-between">
            <span className="pe-3 greyTitle w-25 text-start">
              Question Type
            </span>
            <span className="ps-3 subTitle text-end">
              {questionData?.subCategoryId?.name}
            </span>
          </div>
            </div>
          )}
          
          {localStorage.getItem("serviceType") === "AssignmentHelp" && questionData?.deadlineHours > 0 && !questionData?.deadlineDate && (
            <div className="d-flex  justify-content-between mb-3">
              <span className="pe-3 greyTitle w-25 text-start">
                Deadline
              </span>
              <span className="ps-3 subTitle text-end fw-bold">
                {questionData?.deadlineHours} Hours
              </span>
            </div>
          )}
          {localStorage.getItem("serviceType") === "AssignmentHelp" && questionData?.deadlineDate && (
            <div className="d-flex  justify-content-between">
              <span className="pe-3 greyTitle w-25 text-start">
                Deadline
              </span>
              <span className="ps-3 subTitle text-end">
                {new Date(questionData.deadlineDate).toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true
                })}
              </span>
            </div>
          )}
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
};

export default Requirements;
